import { withInstall } from '@pit-element-plus/utils'
import InputNumber from './src/input-number.vue'

import type { SFCWithInstall } from '@pit-element-plus/utils'

export const ElInputNumber: SFCWithInstall<typeof InputNumber> =
  withInstall(InputNumber)

export default ElInputNumber
export * from './src/input-number'
